import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function PersonAddIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6.99995 9C4.79995 9 2.99995 7.2 2.99995 5V4C2.99995 1.8 4.79995 0 6.99995 0C9.19995 0 10.9999 1.8 10.9999 4V5C10.9999 7.2 9.19995 9 6.99995 9Z" />
        <path d="M4.99995 11C2.5412 11 0.545115 12.6964 0.095087 15.0059C-0.0105462 15.548 0.447664 16 0.999949 16H7.99995V11H4.99995Z" />
        <path d="M11.9999 10H13.9999V12H15.9999V14H13.9999V16H11.9999V14H9.99995V12H11.9999V10Z" />
      </svg>
    </Icon>
  );
}
